import { gql } from 'graphql-tag';
import {
  EXPORT_RUN_FIELDS,
  FORM_CARD_FIELDS,
  FORM_DETAIL_FIELDS,
  FORM_SUBMISSION_ROW_FIELDS,
} from './fragments';

// Canonical mutations (build plan §3.3).

export const CREATE_FORM = gql`
  mutation CreateForm($input: CreateFormInput!) {
    createForm(input: $input) {
      ...FormDetailFields
    }
  }
  ${FORM_DETAIL_FIELDS}
`;

export const SAVE_FORM = gql`
  mutation SaveForm($input: SaveFormInput!) {
    saveForm(input: $input) {
      ...FormDetailFields
    }
  }
  ${FORM_DETAIL_FIELDS}
`;

export const SET_FORM_STATUS = gql`
  mutation SetFormStatus($input: SetFormStatusInput!) {
    setFormStatus(input: $input) {
      ...FormDetailFields
    }
  }
  ${FORM_DETAIL_FIELDS}
`;

export const SET_FORM_STATUS_CARD = gql`
  mutation SetFormStatusCard($input: SetFormStatusInput!) {
    setFormStatus(input: $input) {
      ...FormCardFields
    }
  }
  ${FORM_CARD_FIELDS}
`;

export const ARCHIVE_FORM = gql`
  mutation ArchiveForm($id: Int!) {
    archiveForm(id: $id) {
      ...FormCardFields
    }
  }
  ${FORM_CARD_FIELDS}
`;

export const RESTORE_FORM = gql`
  mutation RestoreForm($id: Int!) {
    restoreForm(id: $id) {
      ...FormCardFields
    }
  }
  ${FORM_CARD_FIELDS}
`;

export const DUPLICATE_FORM = gql`
  mutation DuplicateForm($input: DuplicateFormInput!) {
    duplicateForm(input: $input) {
      ...FormCardFields
    }
  }
  ${FORM_CARD_FIELDS}
`;

export const ADD_FORM_NOTE = gql`
  mutation AddFormNote($input: AddFormNoteInput!) {
    addFormNote(input: $input) {
      id
      body
      author_id
      author_name
      created_at
    }
  }
`;

export const CREATE_SAVED_FORM_FIELD = gql`
  mutation CreateSavedFormField($input: CreateSavedFormFieldInput!) {
    createSavedFormField(input: $input) {
      id
      account_id
      name
      base_type
      config
      created_at
    }
  }
`;

export const DELETE_SAVED_FORM_FIELD = gql`
  mutation DeleteSavedFormField($id: Int!) {
    deleteSavedFormField(id: $id)
  }
`;

export const CREATE_FORM_ASSET_UPLOAD = gql`
  mutation CreateFormAssetUpload($input: CreateFormAssetUploadInput!) {
    createFormAssetUpload(input: $input) {
      file_id
      url
      fields
      expires_at
      max_bytes
    }
  }
`;

// Staff edits to an entry: `answers` holds only the changed fields (null
// clears one). Returns the row so the table and the entry card update.
export const UPDATE_FORM_SUBMISSION_ADMIN = gql`
  mutation UpdateFormSubmissionAdmin($input: UpdateFormSubmissionAdminInput!) {
    updateFormSubmissionAdmin(input: $input) {
      ...FormSubmissionRowFields
    }
  }
  ${FORM_SUBMISSION_ROW_FIELDS}
`;

// Export submissions: queues the file on the worker and returns the run;
// EXPORT_RUN_STATUS follows it and GET_EXPORT_RUN_DOWNLOAD_URL fetches it.
export const EXPORT_FORM_SUBMISSIONS = gql`
  mutation ExportFormSubmissions($input: ExportFormSubmissionsInput!) {
    exportFormSubmissions(input: $input) {
      ...ExportRunFields
    }
  }
  ${EXPORT_RUN_FIELDS}
`;
